var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreemapChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E8F4B792-021D-4DA3-9ECC-9A46C046865B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.0041,0 C29.1061,0 30.0001,0.894 30.0001,1.996 L30.0001,1.996 L30.0001,16.004 C30.0001,17.106 29.1061,18 28.0041,18 L28.0041,18 L23.9961,18 C22.8931,18 22.0001,17.106 22.0001,16.004 L22.0001,16.004 L22.0001,1.996 C22.0001,0.894 22.8931,0 23.9961,0 L23.9961,0 Z M6.004,0.0001 C7.106,0.0001 8,0.8931 8,1.9961 L8,1.9961 L8,10.0041 C8,11.1061 7.106,12.0001 6.004,12.0001 L6.004,12.0001 L1.996,12.0001 C0.894,12.0001 1.77635684e-15,11.1061 1.77635684e-15,10.0041 L1.77635684e-15,10.0041 L1.77635684e-15,1.9961 C1.77635684e-15,0.8931 0.894,0.0001 1.996,0.0001 L1.996,0.0001 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.004,14.0001 C7.106,14.0001 8,14.8931 8,15.9961 L8,15.9961 L8,28.0041 C8,29.1061 7.106,30.0001 6.004,30.0001 L6.004,30.0001 L1.996,30.0001 C0.894,30.0001 1.77635684e-15,29.1061 1.77635684e-15,28.0041 L1.77635684e-15,28.0041 L1.77635684e-15,15.9961 C1.77635684e-15,14.8931 0.894,14.0001 1.996,14.0001 L1.996,14.0001 Z M28.0041,20 C29.1061,20 30.0001,20.894 30.0001,21.996 L30.0001,21.996 L30.0001,28.004 C30.0001,29.106 29.1061,30 28.0041,30 L28.0041,30 L11.9961,30 C10.8931,30 10.0001,29.106 10.0001,28.004 L10.0001,28.004 L10.0001,21.996 C10.0001,20.894 10.8931,20 11.9961,20 L11.9961,20 Z M18.0041,1.77635684e-15 C19.1061,1.77635684e-15 20.0001,0.894 20.0001,1.996 L20.0001,1.996 L20.0001,16.004 C20.0001,17.106 19.1061,18 18.0041,18 L18.0041,18 L11.9961,18 C10.8931,18 10.0001,17.106 10.0001,16.004 L10.0001,16.004 L10.0001,1.996 C10.0001,0.894 10.8931,1.77635684e-15 11.9961,1.77635684e-15 L11.9961,1.77635684e-15 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-203.000000, -776.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(160.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Treemap-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(4.999900, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(4.999900, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreemapChart);
export default __webpack_public_path__ + "static/media/treemapChart.452b6ec58d6985055b85d9b3e3b0c7f6.svg";
export { ForwardRef as ReactComponent };